import { useState, useEffect } from 'react';
import { useNotification } from 'context/notification';
import HostPricingForm from 'pages/hostPricing/HostPricingForm';
import { createHostPricing } from './HostPricingAPI';
import { getDefaultHostPricingValues } from './HostPricingAPI';

export default function HostPricingCreator(props) {
    const { hostId, hostName, onUpdate, onCancel } = props;

    const [loading, setLoading] = useState(false);

    const { notify } = useNotification();

    // Note: When we create a new host, the default host pricing record is not created here. Its created on the backend.
    // If we change a default value here, we also need to change it in the backend.

    const [defaultValues, setDefaultValues] = useState(null);

    useEffect(() => {
        getDefaultHostPricingValues(hostId)
            .then((data) => {
                setDefaultValues({
                    b4tPercent: Number((data.percentFeePerOrder * 100).toPrecision(6)) || null,
                    b4tFlat: data.feePerItem || null,
                    ccPercent: Number((data.ccPercent * 100).toPrecision(6)) || null,
                    ccFlatFee: data.ccFlatFee || null,
                    enableFeeCaps: false,
                    posPercent: Number((data.posPercent * 100).toPrecision(6)) || null,
                });
            })
            .catch((error) => {
                notify.error(String(error));
            });
        // eslint-disable-next-line
    }, [hostId]);

    const handleSubmit = (formData) => {
        if (loading) return;
        setLoading(true);

        createHostPricing(hostId, formData)
            .then(() => {
                notify.success('Host Pricing Created');
                onUpdate();
            })
            .catch((error) => {
                notify.error(String(error));
                setLoading(false);
            });
    };

    if (!defaultValues) {
        return null;
    }

    return (
        <HostPricingForm
            allowEdit={true}
            defaultValues={defaultValues}
            onSubmit={handleSubmit}
            onCancel={onCancel}
            loading={loading}
            hostName={hostName}
        />
    );
}
